import { Children } from 'react';
import cx from 'classnames';

import { MenuList, ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Button from '@classify/react-core-components/Button';
import Loader from '@classify/react-core-components/Loader';
import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  ({ palette }) => ({
    root: {
      maxHeight: 160,
      overflow: 'auto',
    },
    noResults: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    noResultsQuery: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.text.secondary,
    },
  }),
  { classNamePrefix: 'MenuPaginatedList' }
);

const MenuPaginatedList = ({
  children = null,
  isLoading = false,
  translations = {
    noResults: '"XXX" not found',
    loading: 'Loading',
    createButton: 'Create',
    noResultGeneric: 'No results',
  },
  createUrl = '',
  ...otherProps
}) => {
  const classes = useStyles();

  const hasChildren = Children.toArray(children).length > 0;

  const noResult = createUrl ? (
    <>
      <Typography className={classes.noResultsQuery} display="inline" variant="body">
        {translations.noResults}
      </Typography>
      <Button
        sx={{ flexShrink: 0 }}
        variant="tertiary"
        component="a"
        href={createUrl}
        target="_blank"
      >
        {translations.createButton}
      </Button>
    </>
  ) : (
    <Typography className={classes.noResultsQuery} display="inline" variant="body">
      {translations.noResultGeneric}
    </Typography>
  );

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <MenuList className={classes.root} {...otherProps}>
        {children}

        {!hasChildren && (
          <ListItem tabIndex={-1} className={cx({ [classes.noResults]: !isLoading })}>
            {isLoading ? (
              <>
                <Loader size={24} thickness="small" aria-label="" />
                <Typography color="text.secondary" display="inline" variant="bodySmall">
                  {translations.loading}
                </Typography>
              </>
            ) : (
              noResult
            )}
          </ListItem>
        )}
      </MenuList>
    </>
  );
};

export default MenuPaginatedList;
